const dict = {
  chooseLang: "Elegir idioma",
  agree: "Aceptar",

  //Licence
  instructions: "Instrucciones",
  step1: "Paso 1: Escanea el código QR",
  locateqr: "Localiza el código QR a tu derecha.",
  useSmartphone:
    "Usa la cámara de tu smartphone o una aplicación de escaneo QR para escanearlo. Esto te llevará al siguiente paso.",
  step2: "Paso 2: Ingresa la información de la lista de reproducción",
  afterScan: "Después de escanear el código QR, se te pedirá que ingreses la información de tu lista de reproducción.",
  makeSure: "Asegúrate de completar todos los campos requeridos.",
  step3: "Paso 3: Regresa a la aplicación",
  onceYou:
    "Una vez que hayas ingresado los detalles de tu lista de reproducción, puedes volver a la aplicación y continuar tu experiencia.",
  refresh: "ACTUALIZAR",
  playlist: "Lista de reproducción",
  bigPlaylist: "LISTAS DE REPRODUCCIÓN",
  noLicence: "No tienes una licencia.",
  scanLicence: "Escanea para comprar una licencia.",
  noPlaylist: "No tienes ninguna lista de reproducción",
  privacyBig: "MODO PRIVACIDAD",
  scanToAddBig: "ESCANEA PARA AGREGAR LISTA",
  scanToBuyBig: "ESCANEA PARA COMPRAR LICENCIA",
  orVisit: "o visita",
  andenterdeviceID: "e ingresa este ID de dispositivo:",
  removePlaylist: "Eliminar lista de reproducción",
  wantToRemove: "¿Deseas eliminar?",
  cancelBig: "CANCELAR",
  loading: "Cargando...",
  enablePMode: "Por favor activa el Modo Privacidad para continuar viendo.",
  killSwitchProtecting: "El Kill Switch protege tu privacidad bloqueando el acceso cuando el Modo Privacidad está desactivado.",
  kSwitchProtecionActive: "Protección Kill Switch Activa",
  privacyMode: "Modo Privacidad",
  ok: "ACEPTAR",

  //Home
  bigLiveTv: "TV en Vivo",
  bigMovies: "Películas",
  bigSeries: "Series",
  //Channel-Menu
  noChannels: "Esta lista de reproducción no tiene datos de canales",
  searchChannels: "Buscar canal",
  tapToPlay: "Toca para reproducir el stream de video.",
  categoryEmpty: "Esta categoría está vacía",
  pinNotSet: "PIN no configurado",
  setPinNow: " ¿Te gustaría configurar tu PIN ahora?",
  preview: "VISTA PREVIA",
  liveTv: "TV en Vivo",
  addToFav: "Agregar a Favoritos",
  removeFromFav: "Eliminar de Favoritos",
  now: "Ahora:",
  nextPlaying: "A continuación:",
  channels: "Canales",
  noChannelsFound: "No se encontraron canales",

  //Movies
  noMovies: "Esta lista de reproducción no tiene datos de películas",
  searchMovies: "Buscar películas",
  noFavMovies: "No hay películas favoritas",
  //series
  noSeries: "Esta lista de reproducción no tiene datos de series",
  searchSeries: "Buscar series",
  noFavSeries: "No hay series favoritas",
  search: " Buscar",
  thereIsProblem: "Hay un problema en este momento",
  tryAgainLater: "Por favor intenta de nuevo más tarde.",
  series: "Series",
  movies: "Películas",
  noSeriesFound: "No se encontraron series",
  noMoviesFound: "No se encontraron películas",
  //entity
  play: "REPRODUCIR",
  playMovie: "Reproducir película",
  recommendations: "Recomendaciones",
  //User Info
  userInfo: "Información del usuario",
  aboutApp: "Acerca de la aplicación",
  //Userinfo
  account: "Cuenta",
  subscriptions: "Suscripciones",
  privacyPilicy: "Privacidad y Política",
  languge: "Idioma",
  english: "Inglés",
  italian: "Italiano",
  german: "Alemán",
  spanish: "Español",
  french: "Francés",
  saudiArabia: "Árabe",
  chinese: "Chino",
  greek: "Griego",
  turkish: "Turco",
  change_pin: "Cambiar PIN",
  kill_switch: "Kill Switch",
  device_info: "Información del dispositivo",
  unknown: "Desconocido",

  //headers
  settings: "Configuración",
  termsConditions: "Términos y Condiciones",
  home: "Inicio",

  //license
  scanQrCode: "Escanea el código QR para enviar una lista de reproducción",
  managePlaylist: "Gestionar lista de reproducción",
  orVisitt: "O visita",
  scanToAdd: "Escanea para agregar una lista de reproducción o visita",

  //device info
  display: "Pantalla",
  storage: "Almacenamiento",
  network: "Red",
  connection: "Conexión",
  macAddress: "Dirección MAC:",
  deviceId: "ID de dispositivo:",
  pmInfo: "Información del Modo Privacidad",
  statusActive: "Estado: Activo",
  underMaintance: "Estado: En mantenimiento",
  version: "Versión:",
  lastBuildDate: "Fecha de última compilación:",
  lastUpdated: "Última actualización: ",

  //kill switch
  enableKillSwitch: "¿Habilitar Kill Switch?",
  disableKillSwitch: "¿Deshabilitar Kill Switch?",
  whenEnabled: "Cuando está habilitado, OrbixPlay SOLO funcionará cuando el Modo Privacidad esté activado.",
  withOrWithoutPM: "OrbixPlay funcionará normalmente con o sin Modo Privacidad.",
  extra_privacy_protection: " Protección de Privacidad Extra",
  pmOn: "• Si el Modo Privacidad está ACTIVADO: puedes transmitir contenido de forma segura",
  killSwitchDescription: "El Kill Switch proporciona una capa adicional de protección para máxima privacidad.",
  pmOff: "• Si el Modo Privacidad está DESACTIVADO: la aplicación bloqueará el acceso para proteger tu privacidad",
  reenable: "Puedes volver a habilitarlo en cualquier momento para máxima seguridad.",
  cancel: "Cancelar",
  enable: "Habilitar",
  disable: "Deshabilitar",
  killSwitch: "Kill Switch – Protección de Privacidad Extra",
  ipHidden: "Cuando activas el Modo Privacidad, tu dirección IP queda oculta y tu conexión pasa por un sistema seguro — similar a cómo funciona una VPN.",
  extraLayer: "El Kill Switch es una capa adicional de protección: si lo habilitas, OrbixPlay solo funcionará cuando el Modo Privacidad esté activado.",
  ifPmOn: "• Si el Modo Privacidad está ACTIVADO: puedes transmitir contenido de forma segura",
  ifPmOff: "• Si el Modo Privacidad está DESACTIVADO: la aplicación bloqueará el acceso para proteger tu privacidad",
  recommended: "Recomendado para cualquiera que quiera máxima seguridad y nunca quiera transmitir sin protección.",
  current_status: "Estado actual:",
  pressToDisable: "🛡️ HABILITADO - Presiona para deshabilitar",
  pressToEnable: "○ DESHABILITADO - Presiona para habilitar",
  pressEnter: " Presiona Enter en el botón de arriba para cambiar la configuración del Kill Switch",

  //set pin
  pinSetSuccessfully: "¡PIN configurado con éxito!",
  createPin: "Crea tu PIN",
  confirmPin: "Confirma tu PIN",
  confirmYourPin: "confirmPin: 'Confirma tu PIN'",
  initializingPin: "Inicializando configuración de PIN...",
  enterCurrentPin: "Ingresa el PIN actual",
  enterNewPin: "Ingresa el nuevo PIN",
  confirmNewPin: "Confirma el nuevo PIN",
  pinChanged: "¡PIN cambiado con éxito!",
  pinHasChanged: " ¡Tu PIN ha sido cambiado con éxito!",

  //lastones
  playInfo: "Información de la lista de reproducción",
  playName: "Nombre de la lista de reproducción:",
  host: "Host:",
  username: "Nombre de usuario:",
  password: "Contraseña:",
  packName: "Nombre del paquete:",
  expireDate: "Fecha de vencimiento:",

  //privacyPolicy
  one: "1. Descargo de responsabilidad sobre el contenido: OrbixPlay es una plataforma diseñada para mejorar tu experiencia digital. Sin embargo, es importante destacar que OrbixPlay no aloja, proporciona ni distribuye contenido de video. Nuestro servicio está estructurado para apoyar tu viaje digital, pero no somos responsables de la disponibilidad, calidad o contenido del material de video, ya que esto está fuera del alcance de nuestros servicios.",
  two: "2. Sin responsabilidad por contenido de terceros: OrbixPlay LLC no es responsable de ningún contenido de terceros al que puedas acceder a través de nuestra aplicación. Tu participación con cualquier contenido externo, incluida su legalidad, confiabilidad o idoneidad, es exclusivamente bajo tu propio riesgo.",
  three:
    "3. Jurisdicción y Cumplimiento: OrbixPlay LLC opera bajo la jurisdicción de los Estados Unidos. Los usuarios son responsables de garantizar que su uso de la aplicación cumpla con todas las leyes locales, estatales y federales.",
  four: "4. Política de precios: Los precios de los servicios de OrbixPlay están sujetos a cambios en cualquier momento sin previo aviso. Al aceptar este acuerdo, reconoces y aceptas que los precios pueden variar y que dichos cambios no afectarán tu servicio actual hasta la renovación de tu suscripción.",
  five: `5. Sin garantía: La aplicación OrbixPlay y sus servicios se proporcionan "tal cual" sin garantías expresas ni implícitas, incluidas, entre otras, las garantías implícitas de comerciabilidad, idoneidad para un propósito particular y no infracción.`,
  six: "6. Aceptación de los Términos: Al hacer clic en Aceptar, aceptas estar vinculado por los términos de este descargo de responsabilidad y reconoces que cualquier violación puede resultar en la cancelación de tu acceso a los servicios de OrbixPlay.",
  orbixUserAgreement: "ACUERDO DE USUARIO Y DESCARGO DE RESPONSABILIDAD DE ORBIXPLAY",
  beforeyouProcc: "Antes de continuar, por favor lee y acepta los siguientes términos y condiciones:",

  //additional
  exitApp: "Salir de OrbixPlay",
  wantToExit: "¿Estás seguro de que deseas salir de OrbixPlay?",
  Resume: "Reanudar",

  whatsnewinv: "Novedades en la versión v",
  whatsnew: "Novedades",

  resellerInfiniteDevices: "Plan Revendedor: Dispositivos Ilimitados",
  resellerInfiniteDevicesDesc: "La misma lista de reproducción ahora se puede instalar en dispositivos ilimitados — no 5 ni 10, sino tantos como necesites.",
  thankyouforusingorbixplayenjoythenewfeatures: "Gracias por usar OrbixPlay — ¡disfruta de las nuevas funciones!",

  instanthomescreen: "Continuar viendo",
  instanthomescreendesc: "Reanuda tus series y películas justo donde las dejaste.",
  turbomoviesearch: "Función de Favoritos",
  turbomoviesearchdesc: "Guarda tu contenido favorito para acceder rápida y fácilmente en cualquier momento.",
  lighterondataandbattery: "Estabilidad del reproductor mejorada",
  lighterondataandbatterydesc: "Mayor confiabilidad de reproducción y operaciones de búsqueda más fluidas.",
  underthehoodfixes: "Correcciones internas",
  underthehoodfixesdesc: "Varias correcciones de errores y mejoras de rendimiento para una mejor experiencia.",

  proxyMaintenance: 'Mantenimiento del proxy',
  proxyMaintenanceMessage: 'El servidor proxy está actualmente en mantenimiento. Por favor intenta de nuevo más tarde.',

  playlistInformation: 'Información de la lista de reproducción',
  playlistExpDate: 'Fecha de vencimiento de la lista de reproducción: ',

  select_playlist: "Seleccionar Lista de Reproducción",
  choose_playlist: "Elige una lista de reproducción para comenzar a ver",
  invalid_line: "Línea No Válida",
  expire_date: "Fecha de Vencimiento:",
  expired: "Vencido",
  waiting_connection: "Esperando conexión...",
  reconnection_attempt: "Intento de reconexión",
  try_again: "Intentar de Nuevo",
  go_back: "Volver",
  unable_to_resume: "No se Puede Reanudar",
  reconnecting: "Reconectando...",
  no_internet_connection: "Sin Conexión a Internet",
  please_try_again: "No se pudo reiniciar el stream. Por favor, inténtalo de nuevo.",
  restore_stream: "Por favor espera mientras restauramos tu stream.",
  reconnect_automatically: "Verifica tu red y nos reconectaremos automáticamente.",
  check_wifi: "Verifica tu conexión WiFi",
  check_ethernet: "Verifica tu conexión Ethernet / LAN",
  check_internet: "Verifica tu conexión a internet",

  add_playlist_screen: "Agregar Lista",
  add_playlist: "Agregar lista manualmente",
  playlist_name_required: "El nombre de la lista es obligatorio",
  m3u_url_required: "La URL M3U de la lista es obligatoria",
  server_url_required: "La URL del servidor es obligatoria",
  username_required: "El nombre de usuario es obligatorio",
  password_required: "La contraseña es obligatoria",
  orbix_code_required: "El código de host Orbix es obligatorio",
  list_code_required: "El código de lista es obligatorio",
  device_id_required: "El ID del dispositivo es obligatorio",
  device_id: "ID del dispositivo : ",
  playlist_format: "Formato de Lista",
  m3u: "URL M3U",
  username_password: "Usuario / Contraseña",
  orbix_code: "Código Orbix",
  list_code: "Código de Lista",
  playListName: "Nombre de Lista *",
  m3uUrl: "URL de Lista M3U *",
  server_URL: "URL del Servidor *",
  username_req: "Usuario *",
  password_req: "Contraseña *",
  orbix_code_req: "Código de Host Orbix *",
  list_code_req: "Código de Lista *",
  addPlaylist: "Agregar Lista",
  adding: "Agregando...",
  my_playlist: "Mi Lista",
  username_placeholder: "nombre de usuario",
  password_placeholder: "••••••••",

  //stream exceptions
  stream_extension: "Extensión de stream",

  //storage_and_data
  storage_and_data: "Almacenamiento y Datos",

  // ── Parental PIN ──────────────────────────────────────────────────────────
  enter_parental_pin: "Ingresar PIN de control parental",

  // ── Account / Subscriptions labels ───────────────────────────────────────
  status: "Estado",
  active: "Activo",
  expiration: "Vencimiento",
  max_connections: "Máx. Conexiones",
  one_device: "1 Dispositivo",
  created: "Creado",

  // ── Storage & Data screen ─────────────────────────────────────────────────
  section_title: "Almacenamiento y Datos",
  section_subtitle: "Administrar los datos almacenados de la app",
  favourites_label: "Favoritos",
  history_label: "Historial de visualización",
  cleared_label: "Borrado",
  all_cleared_label: "Todo borrado",
  remove_cancel_label: "Cancelar",
  remove_confirm_label: "Borrar",
  clear_fav_channels_title: "Canales favoritos",
  clear_fav_channels_subtitle: "Eliminar todos los canales guardados",
  clear_fav_channels_message: "¿Borrar todos los canales favoritos?",
  clear_fav_movies_title: "Películas favoritas",
  clear_fav_movies_subtitle: "Eliminar todas las películas guardadas",
  clear_fav_movies_message: "¿Borrar todas las películas favoritas?",
  clear_fav_series_title: "Series favoritas",
  clear_fav_series_subtitle: "Eliminar todas las series guardadas",
  clear_fav_series_message: "¿Borrar todas las series favoritas?",
  clear_continue_watching_movies_title: "Continuar viendo – Películas",
  clear_continue_watching_movies_subtitle: "Eliminar progreso de películas",
  clear_continue_watching_series_title: "Continuar viendo – Series",
  clear_continue_watching_series_subtitle: "Eliminar progreso de series",
  clear_continue_watching_title: "Continuar viendo",
  clear_continue_watching_message: "¿Borrar historial de reproducción?",
  clear_all_title: "Borrar todos los datos",
  clear_all_message: "Esto borrará todos los favoritos e historial.",

  // ── Stream Extension screen ───────────────────────────────────────────────
  stream_extension_desc: "Elige cómo se solicitan las transmisiones en vivo desde tu servidor.",
  ts_desc: "Stream MPEG-TS estándar",
  m3u8_desc: "Stream adaptativo HLS",
  current: "Actual",

  // ── Kill Switch modal ─────────────────────────────────────────────────────
  access_restricted: "🛡️ Acceso restringido",
  to_access_playlists: "Para acceder a las listas:",
  enable_privacy_mode_step: "1. Activa el Modo de privacidad desde la pantalla principal",
  disable_kill_switch_step: "2. O desactiva Kill Switch en Ajustes → Kill Switch",
  preparingContent: "Preparando tu contenido",

  // ── Home screen ──────────────────────────────────────────────────────────────
  loading_base: "Cargando",
  live_now: "EN DIRECTO",
  news: "NOTICIAS",
  sport: "DEPORTE",
  kids: "NIÑOS",

  // ── Series details ───────────────────────────────────────────────────────────
  episode: "Episodio",
  no_episodes: "No hay episodios disponibles para esta temporada.",

  searchForChannels: "Buscar canales...",
  kbSpace: "Espacio",
  kbCaps: "Mayúsculas",
  pressOkToPlay: "Pulsa OK para reproducir",
  live: "En vivo",
};

export default dict;